define('views/components/product_image/product_image',['require','backbone','views/base/item_page_view','text!templates/components/product_image/product_image.html'],function(require){

    var Backbone = require('backbone');
    var BaseItemView = require('views/base/item_page_view');

    var temp = require("text!templates/components/product_image/product_image.html");
    return  Backbone.Marionette.ItemView.extend({
        tagName: 'div',
        template: _.template(temp),
        className: 'product-image',

        ui: function() {
            return {
                select2Input: '[data-init-plugin="select2"]',
                submitButton: '#image-submit-button'
            };
        },

        events: {
            'click @ui.submitButton': 'submitButtonClicked',

            'change form input': 'formChanged',
            'change form textarea': 'formChanged',
            'change form select': 'formChanged',
        },

        formChanged: function (event) {
            var changedField = event.currentTarget;
            var value = $(event.currentTarget).val();
            var changeObject = {};
            if(changedField.id !== "image") 
                changeObject[changedField.id] = value;
            else
                changeObject[changedField.id] = changedField.files[0];


            this.model.set(changeObject);

            
        },
        submitButtonClicked : function(){
            var _this = this;
            this.ui.submitButton.addClass('loading');
            var isCreate = _this.model.get('id') === null;

            var fd = new FormData();
            var method = "post";
            var image_id = "";
            var image = this.model.get('image');
            if(this.model.get('id') != 1){
                //this product have image
                method = "put";
                image_id = this.model.get('id') + "/";


            }
            fd.append('product',this.model.get('product'));
            if(typeof(image) === "object"){
                fd.append('image',typeof(image) === "object" ? image : null);
            }
            fd.append('image_width',this.model.get('image_width'));
            fd.append('image_height',this.model.get('image_height'));
            $.ajax({
                url: App.Config.apiBase + 'product-images/' + image_id,
                method: method,
                data: fd,
                processData: false,
                contentType: false,
                headers:{
                    "Content-Disposition": "form-data; name=image; filename=beko-gmp3-product.jpg "
                },
                success:function(response) {
                    _this.ui.submitButton.removeClass('loading');
                    _this.model.set("id",response.id);
                    _this.render();
                    App.utils.showMessage('success', App.polyglot.t('product_image_success'));

                },
                error: function (xhr, ajaxOptions, thrownError) {
                    _this.ui.submitButton.removeClass('loading');

                    // Show error messages
                    if (xhr.responseJSON.errors) {
                        for (var i=0; i<xhr.responseJSON.errors.length; i++) {
                            App.utils.showMessage('error', xhr.responseJSON.errors[i].message);
                        }
                    }
                    else{
                        App.utils.showMessage('error', App.polyglot.t('product_image_error'));
                    }
                }
            });

        }

    });
});
